import type { ModuleFile } from '../../core/modules.ts';

// Módulo «library»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'library',
    title: 'Biblioteca',
    path: 'biblioteca',
    nav: { group: 'Trabajo', label: 'Biblioteca', icon: '♫', order: 4 },
    load: () => import('./LibraryPage.tsx').then((m) => ({ default: m.LibraryPage })),
  },
];
